module.exports = __webpack_public_path__ + "static/media/spinner_gold.bf2438de.gif";